import { render, staticRenderFns } from "./batchImportPolicyInfo.vue?vue&type=template&id=14729db4&scoped=true"
import script from "./batchImportPolicyInfo.vue?vue&type=script&lang=js"
export * from "./batchImportPolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./batchImportPolicyInfo.vue?vue&type=style&index=0&id=14729db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14729db4",
  null
  
)

export default component.exports